<div class="grid-y availability confirm-container">
  <div class="cell small-8 medium-10 large-4 text-center thank-you">
    <h5 class="non-cap small-margin">{{'gather.thank-you' | translate}}</h5>
    <div *ngIf="!isJapanOrder" class="text">
      {{confirmationLabel | translate:{
      responseDate: (availability.gatherResponseDate | date: ('gather.availability.response-date' | translate)),
      agentName:jobPosting.clientServiceManagerName,
      agentEmail:jobPosting.clientServiceManagerEmail}
      }}
    </div>
    <div *ngIf="isJapanOrder" class="text">
      {{'gather.thank-you-text' | translate }}
    </div>
  </div>
  <div *ngIf="(fromRoute === 'not-interested' || !(gather.showOutsideReview && gather.outsideReviewQuantity < 3)) && !isJapanOrder"
       class="cell small-8 medium-10 large-4 callout">
    <div class="cell small-margin">
      <div class="small-12 small-centered text-center columns">
        <img src="../../../assets/images/gather/update_profile.png" class="material-icons large" alt=""/>
      </div>
    </div>
    <div class="cell medium-margin">
      <div class="small-12 small-centered text-center large-margin columns">
        <h5 class="small-margin">{{'gather.update-profile' | translate}}</h5>
        <div class="text">{{'gather.update-profile-text' | translate}}
        </div>
      </div>
    </div>
    <div class="cell medium-margin">
      <div class="small-12 small-offset-0 large-offset-3 medium-8 medium-offset-2 large-6 columns btn-container">
        <button id="interestedUpdateProfile" class="btn-1" (click)="goToUrl('profile')">
          <span>{{'gather.update-my-profile' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="fromRoute === 'interested' && gather.showOutsideReview && gather.outsideReviewQuantity < 3 && !isJapanOrder" class="cell small-8 medium-10 large-4 columns callout">
    <div class="row small-margin">
      <div class="small-12 small-centered text-center columns">
        <img src="../../../assets/images/gather/update_profile.png" class="material-icons large" alt=""/>
      </div>
    </div>
    <div class="row medium-margin">
      <div class="small-12 small-centered text-center large-margin columns">
        <h5 class="small-margin">{{'gather.complete-profile' | translate}}</h5>
        <div class="text">{{'gather.complete-review-text' | translate}}
        </div>
      </div>
    </div>
    <div class="row medium-margin">
      <div class="small-12 small-offset-0 large-offset-3 medium-8 medium-offset-2 large-6 columns btn-container">
        <button id="addReviews" class="btn-1" (click)="goToUrl('reviews')">
          <span>{{'gather.add-reviews' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="fromRoute === 'interested' && !isJapanOrder" class="cell small-8 medium-10 large-4 callout">
    <div class="row small-margin">
      <div class="small-12 small-centered text-center columns">
        <img src="../../../assets/images/gather/tracking_progress.png" class="material-icons large" alt=""/>
      </div>
    </div>
    <div class="cell medium-margin">
      <div class="small-12 small-centered text-center large-margin columns">
        <h5 class="small-margin">{{'gather.track-your-status' | translate}}</h5>
        <div class="text">{{'gather.track-status-text' | translate}}
        </div>
      </div>
    </div>
    <div class="cell medium-margin">
      <div class="small-12 small-offset-0 large-offset-3 medium-8 medium-offset-2 large-6 columns btn-container">
        <button id="trackMyStatus" class="btn-1" (click)="goToUrl('status')">
          <span>{{'gather.track-my-status' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
  <div *ngIf="!isJapanOrder || fromRoute === 'not-interested'" class="cell small-8 medium-10 large-4 callout">
    <div class="row medium-margin">
      <div class="small-12 small-centered text-center columns">
        <img src="../../../assets/images/gather/see_more_jobs.png" class="material-icons large" alt=""/>
      </div>
    </div>
    <div class="cell medium-margin">
      <div class="small-12 small-centered text-center large-margin columns">
        <h5 class="small-margin">{{'gather.see-more-jobs' | translate}}</h5>
        <div class="text">{{'gather.see-more-jobs-text' | translate}}
        </div>
      </div>
    </div>
    <div class="cell medium-margin">
      <div class="small-12 small-offset-0 large-offset-3 medium-8 medium-offset-2 large-6 columns btn-container">
        <button id="interestedVisitJobCenter"  class="btn-1" (click)="goToUrl('job')">
          <span>{{'gather.visit-job-center' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
  <div class="cell small-8 medium-10 large-4 callout" *ngIf="fromRoute === 'not-interested' && !isJapanOrFrance">
    <div class="row small-margin">
      <div class="small-11 small-centered text-center columns">
        <img src="../../../assets/images/gather/refer_a_friend.png" class="material-icons large" alt=""/>
      </div>
    </div>
    <div class="row medium-margin">
      <div class="small-11 small-centered text-center large-margin columns">
        <h5 class="small-margin">{{'gather.not-interested.refer-friend' | translate}}</h5>
        <div class="text">{{'gather.not-interested.refer-text' | translate}}
        </div>
      </div>
    </div>
    <div class="row medium-margin">
      <div class="small-12 small-offset-0 large-offset-3 medium-8 medium-offset-2 large-6 columns">
        <button id="referLearnMore" class="btn-1" (click)="goToUrl('refer')">
          <span>{{'gather.not-interested.learn-more' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</div>
